import ListItem from "@components/list-item";
import { createLinkComponent } from "react-native-ridge-navigation";

const ListItemLink = createLinkComponent(ListItem);
export default ListItemLink;
